import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NgForm } from '@angular/forms';

import {
  ActivityFormatService,AgeGroupService, ArrayService, AuthService, 
  ChurchService, DatabaseService, FestivalUserService   
} from '../../../core/services';

import { PageClass } from '../../../core/classes/page';
import { ActivityFormat, NameValue } from '../../../core/models';

@Component({
  selector: 'app-add-activity-format',
  templateUrl: './add-format.component.html',
  styleUrls: ['./add-format.component.less', '../../../core/styles/common.less']
})

export class AddActivityFormatComponent extends PageClass implements OnInit {

  format: ActivityFormat = new ActivityFormat();

  activityList: NameValue[] = [];
  categoryList: NameValue[] = [];

  activityObj: NameValue = null;
  categoryObj: NameValue = null;

  isLoading: boolean = true;


  @ViewChild('formatForm', null) formatForm: NgForm;

  constructor(
    protected activityFormatService: ActivityFormatService,
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    protected festivalUserService: FestivalUserService,
    protected modalController: ModalController
  ) {
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {
      this.ageLevelList = this.ageGroupService.getAgeLevelList();

      this.activityList = this.currentUser.isAdmin ? 
        this.activityFormatService.getActivityList() :
        this.currentUser.activityList;

      if (this.activityList.length === 1) {
        this.activityObj = this.activityList[0];
        this.onActivitySelected();
      }
      
      this.isLoading = false;
    } else {
      this.dismissModal();
    }
  }

  public async addFormat() {
    if (this.formatForm.invalid) {
      return;
    }

    await this.activityFormatService.createFormat(this.format);
    alert('Format Successfully Created');

    this.dismissModal();
  }

  public onActivitySelected = () => {
    this.format.activity = this.activityObj;
    this.categoryList = this.activityFormatService.getActivityCategoryList(this.format.activity);
  }

  public onCategorySelected = () => {
    this.format.category = this.categoryObj;
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
